import Translator from '../../classes/Translator/Translator';

const GuaranteeLogic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};

export default GuaranteeLogic;
